const animations = {
  left: {
    win: require('./animations/good/win/1.json'),
    fail: require('./animations/good/fail/1.json'),
  },
  right: {
    1: {
      win: require('./animations/bad/win/1.json'),
      fail: require('./animations/bad/fail/1.json'),
    },
    2: {
      win: require('./animations/bad/win/2.json'),
      fail: require('./animations/bad/fail/2.json'),
    },
    3: {
      win: require('./animations/bad/win/3.json'),
      fail: require('./animations/bad/fail/3.json'),
    },
    4: {
      win: require('./animations/bad/win/4.json'),
      fail: require('./animations/bad/fail/4.json'),
    },
    5: {
      win: require('./animations/bad/win/5.json'),
      fail: require('./animations/bad/fail/5.json'),
    },
    6: {
      win: require('./animations/bad/win/6.json'),
      fail: require('./animations/bad/fail/6.json'),
    },
    7: {
      win: require('./animations/bad/win/7.json'),
      fail: require('./animations/bad/fail/7.json'),
    },
    8: {
      win: require('./animations/bad/win/8.json'),
      fail: require('./animations/bad/fail/8.json'),
    },
  },
}

export default animations
